const state = {
    // 配置
    config: {
        clientWidth: 0,
        clientHeight: 0,
        // tablet: 平板 mobile: 手机
        layout: 'mobile',
        headerHeight: 45,
    },
    // 试卷信息
    paperInfo: null,
    // 试题
    moduleList: [],
    // 收藏
    collectionMap: null,
    // 解析
    questionAnalysisMap: null,
    // 用户答案
    userAnswerMap: null,

    // 答题卡显示状态
    questionCardState: false,

    // 当前显示试题 indexNo id
    currentQuestion: null,
    // 当前显示子题目  indexNo id
    currentSubQuestion: null,
    // {questionId: 0, subQuestionId: 0}
    jumpQuestion: null,

    complexTypes: ['LISTENING', 'EREADING_COMPREHENSION', 'COMPREHENSION', 'LISTENING_BLANK', 'LISTENING_MATCH', 'COMPREHENSION_MATCH'],
    listeningComplexTypes: ['LISTENING_BLANK', 'LISTENING_MATCH'],
}
const mutations = {}

const actions = {
    setConfig({ state }, data) {
        state.config.clientWidth = data.clientWidth
        state.config.clientHeight = data.clientHeight
        if (state.config.clientWidth >= 960) {
            state.config.layout = 'tablet'
            state.config.headerHeight = 45
        } else {
            state.config.layout = 'mobile'
            state.config.headerHeight = 42
        }
    },
    setPaperInfo({ state }, data) {
        state.paperInfo = data
    },
    setModuleList({ state }, data) {
        state.moduleList = data
    },
    setCollectionMap({ state }, data) {
        state.collectionMap = { ...state.collectionMap, ...data }
    },
    setQuestionAnalysisMap({ state }, data) {
        state.questionAnalysisMap = data
    },
    setUserAnswerMap({ state }, data) {
        state.userAnswerMap = data
    },
    setQuestionCardState({ state }, data) {
        state.questionCardState = data
    },
    setCurrentQuestion({ state }, data) {
        state.currentQuestion = data
    },
    setCurrentSubQuestion({ state }, data) {
        state.currentSubQuestion = data
    },
    setJumpQuestion({ state }, data) {
        state.jumpQuestion = data
        if (!data.currentSubQuestion) {
            state.currentSubQuestion = null
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
